module.exports = __webpack_public_path__ + "img/coupon-active.1108359f.svg";